import React from "react";
import Joi from "joi";
import { DashBoardLayout } from "../Dashboard/Layout/DashBoardLayout";
import "../TvSubscription/TvSubscription.css";
import { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import arrowDown from '../EducationPins/imagesEducation/arrow-down.svg';
import { ContextProvider } from "../Context";
import { Link } from "react-router-dom";
import style from "../AirTimePage/AirtimeVtu.module.css";
import ConfirmStarTimesPopup from "./StarTimesPopups/confirmStarTimesPopup";
import { InputStarTimesPopup } from "./StarTimesPopups/inputPinStarTimes"
import StarTimesSuccessfulPopup from "./StarTimesPopups/StarTimesSuccessfulPopup";
import nigerianFlag from '../../Components/EducationPins/imagesEducation/Nigeriaflag.svg';
import americaFlag from '../../Components/EducationPins/imagesEducation/Usa.svg';
import britainFlag from '../../Components/EducationPins/imagesEducation/Britain.svg';
import euroFlag from '../../Components/EducationPins/imagesEducation/GBP.svg';
import austriaFlag from '../../Components/EducationPins/imagesEducation/Austria.svg';
import kenyaFlag from '../../Components/EducationPins/imagesEducation/Kenya.svg';
import {VerifyTransPin} from "../../Components/ApiCollection.jsx/ApiBuck";
import {Loader} from "../Loader/Loader";
import {Modal} from "../Screens/Modal/Modal";
import { useNavigate } from "react-router-dom";
import {PostFunction} from "../../Components/ApiCollection.jsx/ApiBuck";
import { GetFunction } from "../ApiCollection.jsx/ApiBuck";
import { BalanceLoading } from "../Loader/Loader";
import {  RestrictionPopUp } from "../../Components/ApiCollection.jsx/ApiBuck";
import { GetLocalStorage } from "../LocalStorage/LocalStorage";
const StarTimes = () => {
const Data = GetLocalStorage();
  const {
    setConfirmStarTimesPopup,
    selectedOptionStarTimes,
    showDropdownStarTimes,
    setShowDropdownStarTimes,
    setSelectedOptionStarTimes,
     inputPin,
      setStarTimesCardName,
      starTimesFlagResult,
      setStarTimesFlagResult,
   // cardName,
     starTimesEmail,
     setStarTimesEmail,
      setStarTimesSmartCard,
    starTimesSmartCard,
   setInputPin,
  setStarTimesDecoderType,
  starTimesDecoderType,
    decoderActive,
    setDecoderActive,
    setMethodImage,
    methodImage,
    isDarkMode,
    fetchedStarTimesPlans,
    starTimesAmount,
    setStarTimesAmount,
    setStarTimesSuccessful,
     setInputPinStarTimes,
     setErrorMessage,
    // setSuccessPopup,
      fetchedGotvPlans,setFetchedGotvPlans,
    fetchedDstvPlans, setFetchedDstvPlans,
    fetchedShowMaxPlans, setFetchedShowMaxPlans,
     setStarTimesOrderId,
     setStarTimesTransactionId,
 //setStarTimesRequestId,
   setStarTimesDescription,
     starTimesSubscriptionResponse,
     setStarTimesSubscriptionResponse,
    newBalance,
    setNewBalance,
    packageStarTimes,
    setPackageStarTimes,
    starTimesMobileNumber,
    setStarTimesMobileNumber,
    setFetchedStarTimesPlans,
    toggleSideBar,
    purchaseStarTimesErrorType,
    setPurchaseStarTimesErrorType,
    setNetworkIssue,
    networkIssue,
    setSessionModal, sessionModal,
    starTimesCardName
    } = useContext(ContextProvider);
      

   
 
    const [isLoading, setIsLoading] = useState(false)
    const [failedPopup, setFailedPopup] = useState(false);
    const [errorFillDecoder, setErrorFillDecoder] = useState(false)
    const [restrictUser, setRestrictUser] = useState(false);
    const [checkNetworkError, setCheckNetworkError] = useState(false)
    const [starTimesVerifyResponse, setStarTimesVerifyResponse] = useState({});
   const [starTimesLoading, setStarTimesLoading] = useState(false);
   const [stateInvalidDecoderNumber, setStateInvalidDecoderNumber] = useState(false);
    const [passDataBalance, setPassDataBalance] = useState({});
    const [starTimesData, setStarTimesData] = useState([]);

            const [balanceLoader, setBalanceLoader] = useState(false)   

    const navigate = useNavigate();

    
    useEffect(()=> {
      // alert("Who do you think is handling that?")
      if( starTimesVerifyResponse?.data?.name?.length < 1 ){
       setStateInvalidDecoderNumber(true);
      }else{
        setStateInvalidDecoderNumber(false)
      }
    },[starTimesVerifyResponse?.data?.name])
           

  const handleOptionClickStarTimes = (option) => {
    //setSelectedOptionStarTimes(option);
    setShowDropdownStarTimes(false);
  };

  const GetOtherDataTv = async(id, path)=> {
    const SuccessHandler = ()=> {
     navigate(path);
    }
    const FailedHandler = async(ErrorType)=> {
     if(ErrorType === "unauthorised"){
     await GetFunction(TvPath, 
      setIsLoading, 
      SuccessHandler, 
      (ErrorType)=> {
        if(ErrorType === "unauthorised"){
        return setSessionModal(true);
        }
      },
       fetchedResponse)
     }
    }
   
    const SubscriptionPresent =()=> {
     if((fetchedDstvPlans.status === 200 || fetchedDstvPlans.status ===  201) && id === 2 ){
       return navigate(path)
     }else if((fetchedGotvPlans.status === 200 || fetchedGotvPlans.status === 201) && id === 3) {
      return navigate(path)
     }else if((fetchedShowMaxPlans.status === 200 || fetchedShowMaxPlans.status === 201) && id === 4) {
      return navigate(path)
     }
     
    }
   
    let TvPath;
    let fetchedResponse;
     if((fetchedDstvPlans.status === undefined || fetchedDstvPlans.status === null) && id === 2 ){
       TvPath = `products/tvsub/dstv`;
     fetchedResponse = setFetchedDstvPlans;
      await GetFunction(TvPath, setIsLoading, SuccessHandler, FailedHandler, fetchedResponse, setNetworkIssue)
     
    }else if((fetchedGotvPlans.status === undefined || fetchedGotvPlans.status === null) && id === 3){
       TvPath = `products/tvsub/gotv`;
     fetchedResponse = setFetchedGotvPlans;
      await GetFunction(TvPath, setIsLoading, SuccessHandler, FailedHandler, fetchedResponse, setNetworkIssue)
    
   }else if ((fetchedShowMaxPlans.status === undefined || fetchedShowMaxPlans.status === null) && id === 4){
     TvPath = `products/tvsub/showmax`;
     fetchedResponse = setFetchedShowMaxPlans;
      await GetFunction(TvPath, setIsLoading, SuccessHandler, FailedHandler, fetchedResponse, setNetworkIssue)
    
   }else{
     return SubscriptionPresent();
   }
   }



   //Function to Get User's Balance
     const GetBalance = async () => {
       if(!navigator.onLine) return setCheckNetworkError(true)
         const SuccessHandler = (response) => {
          setPassDataBalance(response)
        };
         const FailedHandler = async (ErrorType) => {
           if (ErrorType === "unauthorised") {
             if(sessionModal) return;
             if(!sessionModal) return setSessionModal(true)
           }else if(ErrorType === "Network error" || ErrorType === "User error"){
          if(networkIssue) return;
          if(!networkIssue) return setNetworkIssue(true)
           setCheckNetworkError(true)
           }else{
             alert("An unexpected error occured in attempt to retrieve balance.")
           }
         }
         await GetFunction(
           "balance",
           setBalanceLoader,
           SuccessHandler,
           FailedHandler,
          ()=> {},
          setNetworkIssue
         );
       };

       // ======The Function to get starTimes Plans=====//
        const RetrieveStarTimesPlans = async()=> {
             const SuccessHandler = ()=> {
       return;
      }
        const failedHandler = async(ErrorType)=> {
          if(ErrorType === "unauthorised"){
           if(sessionModal) return;
           if(!sessionModal) return setSessionModal(true)
          }else if(ErrorType === "Server error"){
        alert("Unable to retrieve the starTimes information")
        }else if(ErrorType === "Network error" || ErrorType === "User error"){
          if(networkIssue) return;
          if(!networkIssue) return setNetworkIssue(true)

}      
       }
         
    await GetFunction(`products/tvsub/startimes`, 
      setIsLoading, SuccessHandler, failedHandler, setFetchedStarTimesPlans,setNetworkIssue);
   
     }
   const starTimesOptionalPlan = starTimesData?.length < 1 && fetchedStarTimesPlans.status === 200 ? fetchedStarTimesPlans.data.data.data : starTimesData;
         useEffect(()=> {
          if(Data?.ConfirmAcc === "true"){
          if(fetchedDstvPlans.status === 200 || fetchedDstvPlans.status === 201){
         setStarTimesData(fetchedStarTimesPlans.data.data.data);
         }else if(fetchedStarTimesPlans.status === undefined){
            RetrieveStarTimesPlans()
   }
    // Simulate async data loading
       
         if(newBalance === "" ||
           newBalance === null || 
              newBalance === undefined) {
                  GetBalance();
                if(GetBalance){
               setNewBalance(passDataBalance?.data?.data?.data !== undefined 
                ? passDataBalance?.data?.data?.data?.balance : "");
              }} }else {
                setRestrictUser(true);
              }
        //eslint-disable-next-line             
         },[])
          
     
     
   

  
  const Decoders  = [
    { decoderType :'StarTimes',  id : 1},
      { decoderType :'DStv', path :  "/DsTv", id : 2 },
      { decoderType :'GOtv', path : "/GoTv", id : 3 },
    { decoderType :'Showmax', path : "/Showmax", id : 4 }
     ]


  // function waecQuantityDropDown(){
  //   setQuantityActive(!quantityActive);
  // document.querySelector('.imgdrop').classList.toggle('DropIt');
  // }


  const handleTvEmail = (e) => {
    const inputValue = e.target.value;
    setStarTimesEmail(inputValue);
    setStarTimesSubscriptionResponse({});
  }

  // const handleStarTimes = (event) => {
  //   event.preventDefault();
  //   setConfirmStarTimesPopup(true)
  // }
  const handleStarTimes = (event) => {
    event.preventDefault();
    
    const { error } = schema.validate({
      starTimesMobileNumber,
      starTimesEmail,
      starTimesSmartCard,
    });
  
    if (error) {
      setErrors(
        error.details.reduce((acc, curr) => {
          acc[curr.path[0]] = curr.message;
          return acc;
        }, {})
      );
    }
     else {
      setConfirmStarTimesPopup(true);
      setErrors({});
    }


};
  const [errors, setErrors] = useState({});
 
  // const StarTimesSchema = Joi.object({
  //   mobileNumber: Joi.string().regex(/^\d{11}$/).required(),
  // });

  const schema = Joi.object({
    starTimesSmartCard: Joi.string().regex(/^\d{10,}$/).required()
      .messages({
        "string.pattern.base": "Smart card number should be more than 10 digits",
      }),
    starTimesMobileNumber: Joi.string().regex(/^\d{11}$/).required()
      .messages({
        "string.pattern.base": "Phone number should be 11 digits",
      }),
      starTimesEmail: Joi.string()
      .pattern(new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i))
      .required()
      .messages({ "string.pattern.base": "Invalid email" 
    })
  });

  const handleStarTimesMobileNumberChange = (e) => {
    const inputValue = e.target.value;
    setStarTimesMobileNumber(inputValue);

    // const validation = StarTimesSchema.validate({ mobileNumber: inputValue });

    // if (validation.error) {
    //   setStarTimesErrorMessage('Incorrect Phone Number..');
    // } else {
    //   setStarTimesErrorMessage('');
    // }
  };

 
  const { methodPayment, setMethodPayment } = useContext(ContextProvider);
  const {starTimesWalletBalance,setStarTimesWalletBalance } = useContext(ContextProvider);



  function methodDropDown() {
    setMethodPayment(!methodPayment);
    document.querySelector('.methodDrop').classList.toggle('DropIt');
  }

   const updateBalance = passDataBalance?.data?.data?.data !== undefined  ? passDataBalance?.data?.data?.data?.balance : "";
   const updateBalanceToNumber = Number( updateBalance);
  const newBalanceToNumber = Number(newBalance)
  const methodOptions = [
    { method: 'NGN Wallet',
       balance: newBalance === "" || 
       newBalance === null ||
        newBalance === undefined  ? 
        `(${updateBalanceToNumber?.toLocaleString("en-NG",{
               style : "currency",
               currency : "NGN"
              })})` : `(${ newBalanceToNumber?.toLocaleString("en-NG",{
               style : "currency",
               currency : "NGN"
              }) })`,  
    flag: nigerianFlag, id: 1 },
    { method: 'USD Wallet ', balance: '($0.00)', flag: americaFlag, id: 2 },
    { method: 'EUR Wallet', balance: '(€0.00)', flag: britainFlag, id: 3 },
    { method: 'GBP Wallet', balance: '((£0.00)', flag: euroFlag, id: 4 },
    { method: 'AUD Wallet', balance: '(AU$0.00)', flag: austriaFlag, id: 5 },
    { method: 'KES Wallet', balance: '((KSh0.00)', flag: kenyaFlag, id: 6 }
  ]

  function packageDropdown() {
    if (!starTimesDecoderType) {
      setShowDropdownStarTimes(false);
      setErrorFillDecoder(true)
    }
    else {
    setShowDropdownStarTimes(!showDropdownStarTimes)
      document.querySelector('.imgdrop').classList.toggle('DropIt');
      setErrorFillDecoder(false)
    }
  }

  function decoderDropdown() {
    setDecoderActive(!decoderActive)
    document.querySelector('.decdrop').classList.toggle('DropIt');
  }

    const handleReceivedData = () => {
    setIsLoading(true);
    const receivedData = () => {
      // Seting the relevant data from the TV subscription response
      setStarTimesOrderId(starTimesSubscriptionResponse?.data ? starTimesSubscriptionResponse?.data?.order_id : "");
      setStarTimesTransactionId(starTimesSubscriptionResponse?.data?.transaction_id ? starTimesSubscriptionResponse?.data?.transaction_id : ""  );
     // setStarTimesRequestId(starTimesSubscriptionResponse.data.request_id);
      setStarTimesDescription(starTimesSubscriptionResponse?.data?.transaction_description ? starTimesSubscriptionResponse?.data?.transaction_description : "");
     }
   receivedData();
     if(receivedData) {
      setStarTimesSuccessful(false);
      setIsLoading(false);
      navigate("/StarTimesReceipt");
    }
  };

// VerifyPinHandler to handle both success and failure cases:
const VerifyPinHandler = async () => {
    const StarTimesHandler = async () => {
      const requestData = {
        decoder_type: starTimesDecoderType.toLowerCase(),
        package:  packageStarTimes,
        iuc_number: starTimesSmartCard,
        email: starTimesEmail,
        amount: starTimesAmount,
        phone: starTimesMobileNumber,
        card_name : starTimesCardName
      };
      const Path = "bills/tvsub";
      const successHandler = (response) =>{
          setNetworkIssue(true);
       if(response?.data?.data?.data?.status === "success"
          || response?.data?.data?.data?.status === "delivered"
        ||  response?.data?.data?.data?.status === "successful" ||
        response?.data?.data?.data?.status === "Successful"
        ){
          setPurchaseStarTimesErrorType("");
        setStarTimesSuccessful(true);
        setInputPinStarTimes(false);
        setInputPin("");
        }else if(response?.data?.data?.data?.status === "failed"
          || response?.data?.data?.data?.status === "Failed"
        ||  response?.data?.data?.data?.status === "unsuccessful"){
            setPurchaseStarTimesErrorType("Plan Unavailable: Purchase Failed")
          setFailedPopup(true);
          setInputPinStarTimes(false);
          setInputPin("");
        }
      //  handleReceivedData()
      }
      const FailedHandler = async(ErrorType) =>{
         if(ErrorType === "unauthorised"){
             if(sessionModal) return;
             if(!sessionModal) return setSessionModal(true)
               }else if(ErrorType === "Server error"){
                 //Why arepition did not occur here,
                 //We dont want it to be only about User experience here,
                 //There are several things that could happen to the backend,
                 // and there is also a possibility that the server was able to process and 
                 //initiate the transaction but still returned 500,
                 //so we need to prevent the case of carrying two transaction for a user,
                 //which doesn't only affect us through service of the platform we are using,
                 //but also unrest and panic to the user and the amount for purchase and 
                 //been removed twice without a result or successful output.
                 setPurchaseStarTimesErrorType("Server Error: Purchase Failed")
              setFailedPopup(true);
              setInputPinStarTimes(false);
                setInputPin("")
               }else if(ErrorType === "Network error" || ErrorType === "User error"){
                 setPurchaseStarTimesErrorType("Network Error: Purchase Failed");
                 setFailedPopup(true);
              setInputPinStarTimes(false);
                setInputPin("")
               }else {
                    setPurchaseStarTimesErrorType("An unexpected error has occured");
                 setFailedPopup(true);
              setInputPinStarTimes(false);
                setInputPin("")
               }
    }
      
      await PostFunction(
        Path,
        setIsLoading,
        requestData,
        successHandler,
        FailedHandler,
       setStarTimesSubscriptionResponse,
       setNetworkIssue
      );
    };
    const setFailedConfig= async(ErrorType)=> {
    if(ErrorType === "unauthorised"){
    if(sessionModal) return;
    if(!sessionModal) return setSessionModal(true)
    }else if(ErrorType === "Server error"){
      alert("Pin Verification Failed")
    }else if(ErrorType === "Network error" || ErrorType === "User error"){
         if(networkIssue) return;
        if(!networkIssue) return setNetworkIssue(true)
    }else{
    alert("An unexpected error")
  }
 }
   await VerifyTransPin(inputPin,
      setFailedConfig,
      setIsLoading,
      setErrorMessage,
      StarTimesHandler,
      setNetworkIssue
     );
 };

 let userVerifiedName = starTimesVerifyResponse?.data ? starTimesVerifyResponse?.data?.name : "";
 //Function to help Verify users account
 const VerifyUserAccount = async(UserTvSubscription)=> {
  setStarTimesVerifyResponse({});
  setStateInvalidDecoderNumber(false);
     const body = {
            decoder_type : starTimesDecoderType.toLowerCase(),
           iuc_number : UserTvSubscription
         }
         const bodyToJson = JSON.stringify(body);
  const SuccessHandler = (response)=> {
    setNetworkIssue(true);
   setStarTimesSmartCard(UserTvSubscription);
    setStarTimesCardName(response?.data?.data?.data?.name);
 }
 const FailedHandler = async(ErrorType)=> {
     if(ErrorType === "unauthorised"){
      if(sessionModal) return;
      if(!sessionModal) return setSessionModal(true)
    }else if(ErrorType === "Network error" || ErrorType === "User error"){
         if(networkIssue) return;
        if(!networkIssue) return setNetworkIssue(true)
    }  else if(ErrorType === "Bad request"){
          setStateInvalidDecoderNumber(true)
         }else {
      //4. Handling the "alien" ErrorType.
       alert("An unexpected error has occured, try again some other time.")
    }
 
  
  }  
  
     
 
     if(UserTvSubscription?.length >= 10 && 
     (UserTvSubscription !== "" && 
       UserTvSubscription !== null && 
       UserTvSubscription !== undefined)){
      
 await PostFunction("bills/verify", 
  setStarTimesLoading,
   bodyToJson,
   SuccessHandler,
   FailedHandler,
   setStarTimesVerifyResponse , setNetworkIssue)
 }
}
 

 
  const handleSmartCard = async(e) => {
     const inputValue = e.target.value;
   await VerifyUserAccount(inputValue);
  }

  //To exit the failed popup with the done button.
  const ExitTheDoneButton = ()=> {
      setStarTimesEmail("")
   setStarTimesMobileNumber("")
   setStarTimesSmartCard("");
   setStarTimesAmount("");
   setSelectedOptionStarTimes("");
   setPackageStarTimes("");
   setStarTimesDecoderType("")
    setStarTimesFlagResult("");
    setStarTimesWalletBalance("");
    setFailedPopup(false);
  //navigate("/StarTimes");
  }

   const ReceiptButton = ()=> {
      setFailedPopup(false);
     handleReceivedData();
  }

  if(Data?.ConfirmAcc === "true"){
window.addEventListener("online", ()=> {
   if(checkNetworkError === true &&
     (updateBalance === undefined || updateBalance === null || updateBalance === "")
    && (newBalance === null || newBalance === undefined || newBalance === "") ){
   return GetBalance();
   }
   if( (fetchedDstvPlans.status !== 200 || fetchedDstvPlans.status === undefined) ) {
    return RetrieveStarTimesPlans();
   }
  })
}
const timer = useRef(null)
  return (
    <div>
      <DashBoardLayout>

        <div className={style.AirtimeTops}>
          <div className={style.airtimeTop}>
            <div>
            <div id='tvBackground' className="min-h-[90px] py-[15px] lg:h-[196px] md:h-[112.29px] rounded-[6.6px] md:rounded-[11.46px] lg:rounded-[20px] mx-auto  flex gap-6 justify-between px-[16.51px] md:px-[28.65px] lg:px-[50px]">
              <div className="py-[9.57px] md:py-[16.61px] align-middle self-center flex flex-col gap-1.5 w-[70%]">
                                <p className="text-[11px] leading-[13px] lg:leading-[30px] lg:text-[24px] md:text-[13.75px] font-semibold">
                                    SUBSCRIBE YOUR TV CHANNELS WITH AREMXYPLUG.
                                    </p>
                                <p className="text-[10px] leading-[13px] lg:leading-[25px] lg:text-[20px] md:text-[11.46px]">
                                Never miss a beat! Subscribe your tv channels on our platform to watch and stream your favorite movies without any hassle.
                                </p>
                            </div>
                            <div className="flex w-[23%] h-[97%] pt-2 shrink-0">
                                <img src="./Images/TvSubscription/tv.svg" alt="" className="" />
                            </div>
                        </div>

        <div className=" mx-auto flex gap-1.5 py-[25.29px] lg:py-[37px] md:py-[28.64px] mb-5">
          <div className="flex text-[#7E7E7E] text-[13px] lg:text-[18px] md:text-[13px] font-semibold">
            <span>Subscribe Your</span> &nbsp;
            <img src="./Images/TvSubscription/startimesIcon.svg" alt="" className="md:w-[74px] md:h-[27px] lg:w-[90px] lg:h-[35px]" />
            <span>Decoder Instantly</span>
          </div>
          <img src="./Images/currencyImages/right.svg" alt="" className="lg:h-[24px] lg:w-[24px] md:h-[13.75px] md:w-[13.75px]" />
        </div>

        <div className="flex flex-col gap-[20px] md:gap-0">
          <div className="flex flex-col md:flex-row gap-[20px] md:gap-[12px] lg:gap-[22px] md:my-2 lg:my-4">
            <div className="relative flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType" 
                className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Confirm Decoder Type</label>
              {/* <button className="border-[0.23px] lg:border-[0.4px] w-full md:w-1/2 h-[30px] md:h-[35px] lg:h-[50px] border-[#9C9C9C]">StarTimes</button> */}
              <div onClick={decoderDropdown}
              className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}
    >
                {starTimesDecoderType}
                <img className="absolute left-[90%] lg:left-[94%] self-center align-middle decdrop md:h-[14.038px] md:w-[14.038px] 
      lg:h-[24px] lg:w-[24px] w-[14px] h-[16px] " src={arrowDown} alt="" />
              </div>

              {decoderActive && (
         <div className='absolute lg:top-[90px] md:top-[60px]  top-[74px] z-[2]  flex flex-col w-[100%] lg:h-225px md:h-[210px]  
        '>
          {(Decoders.map(decoder => {
            return (
               <p
               onClick={(e =>{
                GetOtherDataTv(decoder.id, decoder.path)
          setStarTimesDecoderType(decoder.id === 1 ? decoder.decoderType : "");
                 setDecoderActive(false);
             document.querySelector('.decdrop').classList.remove('DropIt');
              })}
              className={`pb-[20px] md:pb-[14px] pt-[20px] md:pt-[14px] font-weight-bold text-[15px] leading-[10.4px] md:py-[15px] py-[8px] pl-[10px] font-[500] text-[#7C7C7C]  
         md:text-[13.227px] md:leading-[17.195px] 
         shadow-[0px_3.30667px_8.26667px_0px_rgba(0,0,0,0.25)] 
         lg:text-[16px] lg:leading-[20.8px] cursor-pointer   ${
        isDarkMode
            ? "bg-black text-white border border-white"
            : "bg-white hover:bg-[#EDEAEA]"
       }`} 
         key= {decoder.id}>
      <h2>{decoder.decoderType}   </h2>
         </p>
        
            )
          }))}
         
          
             </div>
      )}
            </div>

            <div className="relative flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType" 
               className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Select Package</label>

              <div onClick ={packageDropdown}  className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}>
                {selectedOptionStarTimes}
                <img className="absolute left-[90%] lg:left-[94%] self-center align-middle imgdrop  md:h-[14.038px] md:w-[14.038px] 
      lg:h-[24px] lg:w-[24px] w-[14px] h-[16px]" src={arrowDown} alt="" />
              </div>

              {showDropdownStarTimes && (
                <ul className="dropdown-options z-[2] absolute top-[100%] w-full bg-white 
                cursor-pointer h-[300px] overflow-y-scroll">
                  {starTimesOptionalPlan.map((option, index) => (
                    <li
                      className={`pb-[20px] md:pb-[14px] pt-[20px] md:pt-[14px] font-weight-bold
                         text-[14px] leading-[10.4px] md:py-[15px] py-[8px] pl-[10px] font-[500] 
                      md:text-[13.227px] md:leading-[17.195px] 
                      shadow-[0px_3.30667px_8.26667px_0px_rgba(0,0,0,0.25)] 
                      lg:text-[16px] lg:leading-[20.8px] cursor-pointer  dropdownCSS 
                       ${
        isDarkMode
            ? "bg-black text-white border border-white"
            : "border-[#9C9C9C] bg-white text-[#7C7C7C] hover:bg-[#EDEAEA]"
       }`}
                      key={index}
                      onClick={() => {
                        handleOptionClickStarTimes();
                        setStarTimesAmount(option?.Amount)
                        setSelectedOptionStarTimes(`${option?.PackageName}`)
                        setPackageStarTimes(option?.Package);
                      }}
                    >
                     {`${option?.PackageName}`}
                    </li>
                  ))}
                </ul>
              )}
                {errorFillDecoder && (
                <p className="text-[12px] leading-[14px] font-semibold 
                lg:text-[14px] lg:leading-[20px] text-left text-red-700">
                 Select a decoder to choose a package
                </p>
              )}

            </div>


          </div>
          <div className="flex flex-col md:flex-row gap-[20px] md:gap-[12px lg:gap-[22px]] md:my-2 lg:my-4">
            <div className="flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType" 
                className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Smart Card / IUC Number</label>
              <input type="tel"
             
              onInput={(e =>{
                const numericValue = e.target.value.replace(/\D/g, '');
                    e.target.value = numericValue
                })}
                placeholder={"XXXXXXXXXX"}
                onChange={(e)=> {
                    if(timer.current) clearTimeout(timer.current)   
                timer.current = setTimeout(()=> {
              //Run every 5 seconds
                handleSmartCard(e)
                    
  },500)
  return ()=> clearTimeout(timer.current);
                }} 
            className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}/>
            {errors.starTimesSmartCard && <p className="text-[#F95252] text-[9px] md:text-[12px] lg:text-[14px] font-[400] italic">
                {errors.starTimesSmartCard}</p>}
                  {(!errors.starTimesSmartCard && stateInvalidDecoderNumber) && (
                   <p className ="text-[14px] top-0 font-[500] text-red-500 text-left
           lg:text-[14px] lg:leading-[20px] leading-[18px] ">
            Invalid iuc number
          </p>
                )}
            </div>
            

            <div className="flex flex-col relative gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType"
                className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Card Name</label>
              <input type="text"
               placeholder="Input card number to get verified name"
              value={userVerifiedName}
              readOnly
        className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}   />
  {starTimesLoading && (
    <p className ="absolute left-[10px] top-[60%]">
     <BalanceLoading/>
    </p>
  )}
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-[20px] md:gap-[12px] lg:gap-[22px] md:my-2 lg:my-4">
            <div className="flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType" 
               className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Phone Number</label>
              <input id="val" value={starTimesMobileNumber}
                onInput={(e =>{
    
                  const numericValue = e.target.value.replace(/\D/g, '');
                      e.target.value = numericValue
                     if(numericValue.length === 11){
                      e.target.style.border = '2px solid green';
                    }
                    else if(e.target.value.length < 11){
                    e.target.style.border = '2px solid red';
                  }
                
                   })}
             placeholder="XXX XXXX XXXX"
          onChange={handleStarTimesMobileNumberChange} type="tel" maxLength={11}
          className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}     />
              {errors.starTimesMobileNumber && <p className="text-[#F95252] text-[9px] md:text-[12px] lg:text-[14px] font-[400] italic">
                {errors.starTimesMobileNumber}</p>}
            </div>
            <div className="flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="Email" 
               className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Email</label>
              <input type="email"
               onChange={handleTvEmail}
                placeholder="example@gmail.com"
               required 
               className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}      />
             {errors.starTimesEmail && <p className="text-[#F95252] text-[13.4px] md:text-[12px] lg:text-[14px] font-[400] italic">
                {errors.starTimesEmail}</p>}
            </div>

          </div>
          <div className="flex flex-col md:flex-row gap-[20px] md:gap-[12px] lg:gap-[22px] md:my-2 lg:my-4">
            <div className="flex flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType"
                className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Amount</label>


              <input
              palceholder="0.00"
                type="text"
                readOnly
                className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}
                value={(starTimesAmount !== undefined || starTimesAmount !== "") ? starTimesAmount?.toLocaleString("en-NG", {
                  style :"currency",
                  currency : "NGN"
                }): "₦"}
              />

            </div>

            <div className="flex relative flex-col gap-[3px] lg:gap-[5px] w-full md:w-1/2">
              <label htmlFor="decoderType" 
               className={` ${isDarkMode ? "text-white" : "text-black"} text-[14px] lg:text-[17px]
                       md:text-[13px]
                      md:font-[600] font-[400`}>
                Payment Method</label>
              <div onClick={methodDropDown}
               className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`}    >
                <p className={`font-[500] text-base leading-[20px] md:text-[9.389px] 
                md:leading-[12.206px] lg:text-[16px] text-[#7C7C7C] lg:leading-[20.8px] cursor-pointer
                ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>
                   {`${starTimesFlagResult}  ${" "} ${starTimesWalletBalance}`}
                </p>
                <img className='methodDrop h-[16px] w-[14px] md:h-[14.038px] md:w-[14.038px] lg:h-[24px] lg:w-[24px]'
                  src={methodImage} alt="" />
              </div>
              {methodPayment && (
                <div className={`absolute top-[102%] z-0 flex flex-col w-[100%]  cursor-pointer
                  ${
                    isDarkMode
                      ? "bg-black border-white rounded-[7px] text-white"
                      : "text-[#7C7C7C] bg-white rounded-br-[7px] rounded-bl-[7px] lg:rounded-br-[14px] lg:rounded-bl-[14px]"
                  }
                  ${
                    toggleSideBar
                      ? "lg:w-[31.5%] lg:top-[100.5%]"
                      : "lg:w-[38.5%] lg:top-[105.3%]"
                  }  shadow-xl border w-full lg:w-full  flex flex-col divide-y absolute top-20`}>
                
  

                  {(methodOptions.map(methodOption => {
                    return (
                      <div
                        onClick={(e) => {
                           setStarTimesFlagResult(methodOption.id === 1 ? methodOption.method : (starTimesFlagResult === "NGN Wallet" && methodOption.id !== 1 ) ? "NGN Wallet" : "");
                          setStarTimesWalletBalance(methodOption.id === 1 && starTimesWalletBalance === ""? 
                                                                                    newBalance === "" || newBalance === null || newBalance === undefined
                                                              ? `(${updateBalance?.length > 1 ? updateBalanceToNumber?.toLocaleString("en-NG", {
                                                                   style : "currency",
                                                                   currency : "NGN"
                                                              }) : ""})`
                                                              : `(${newBalance?.length > 1 ? newBalanceToNumber?.toLocaleString("en-NG", {
                                                                style : "currency",
                                                                currency : "NGN"
                                                              }) : ""})` : starTimesFlagResult === "NGN Wallet"  ?  newBalance === "" || newBalance === null || newBalance === undefined
                                                              ? `(${updateBalance?.length > 1 ? updateBalanceToNumber?.toLocaleString("en-NG", {
                                                                   style : "currency",
                                                                   currency : "NGN"
                                                              }) : ""})`
                                                              : `(${newBalance?.length > 1 ? newBalanceToNumber?.toLocaleString("en-NG", {
                                                                style : "currency",
                                                                currency : "NGN"
                                                              }) : ""})` : "");
                          setMethodImage(methodOption.id === 1 ? methodOption.flag : methodImage);
                                setMethodPayment(false);
                               setMethodPayment(()=> {
                            if(methodOption.id === 1){
                            setMethodPayment(false)
                             document.querySelector('.methodDrop').classList.remove('DropIt');
                            }else{
                              setMethodPayment(true);
                                document.querySelector('.methodDrop').classList.add('DropIt');
                            }})}}
                               
        className={`py-[18px] md:py-[14px] font-normal px-2 flex
                         items-center gap-[5px] text-[12px] md:text-[14px] 
                         lg:text-[16px] shadow-[0px_3.30667px_8.26667px_0px_rgba(0,0,0,0.25)]
                          transition-all duration-300 hover:bg-slate-50
                       ${
                         isDarkMode
                           ? "text-white hover:bg-slate-800 bg-black "
                           : "text-[#7E7E7E]"
                       } ${
                        methodOption.method === "NGN Wallet"
                          ? "cursor-pointer"
                          : "cursor-not-allowed opacity-50"
                      }`}
                        key={methodOption.id} >
        <img className='md:h-[29.27px]  h-[14.27px]' src={methodOption.flag} alt="" />
 
                          {methodOption.method } {" "}
                          { balanceLoader === true && methodOption.id === 1 ? <BalanceLoading/> :  methodOption.balance}
                       
                      </div>

                    )
                  }))}
                </div>
              )}

            </div>
          </div>
        </div>

        <button onClick={handleStarTimes}
          disabled={starTimesMobileNumber.length !== 11 || !userVerifiedName || !starTimesEmail || !starTimesSmartCard || !starTimesDecoderType || !selectedOptionStarTimes || !starTimesFlagResult}
          className={`
             ${starTimesMobileNumber.length !== 11 || !userVerifiedName || !starTimesEmail || !starTimesSmartCard || !starTimesDecoderType || !selectedOptionStarTimes || !starTimesFlagResult
              ? "bg-[#63616188] "
              : "bg-primary"
            }
            mt-[38px] md:mt-[30px] lg:mt-[25px] rounded-[6px] md:rounded-[10px] lg:rounded-[15px] bg-[#04177F] h-[43px] md:h-[30px] lg:h-[40px] flex items-center font-semibold text-[12px] md:text-[11px] lg:text-[16px] text-[#fff] w-full md:w-[100px] lg:w-[170px] justify-center`}>
          Proceed</button>
            </div>
          </div>

          <div className={style.help}>
            <h2>You need help?</h2>
            <Link to={`/contactUs`} className={style.btnContact}>Contact Us</Link>
          </div>

        </div>

      </DashBoardLayout>
      <ConfirmStarTimesPopup passDataBalance={passDataBalance} userVerifiedName ={userVerifiedName} />
      <InputStarTimesPopup VerifyPinHandler={VerifyPinHandler}/>
      <StarTimesSuccessfulPopup handleReceivedData = {handleReceivedData} userVerifiedName={userVerifiedName}/>
            {/* Failed Transaction Popup */}
      {failedPopup && (
        <Modal>
             <div  className={`w-[90%] md:w-[50%] lg:w-[35%] mx-auto 
           rounded-lg overflow-hidden
            ${isDarkMode ? "bg-black border-[1px] rounded-[7px] border-white": "bg-white"}`}>
               <div className="flex justify-between items-center p-4">
                 <img
          className={`w-6 h-6`}
                src="/Images/login/arpLogo.png"
                alt="Logo"
              />
              <img
                onClick={() => setFailedPopup(false)}
                className="w-6 h-6 cursor-pointer"
                src="/Images/transferImages/close-circle.png"
                alt="Close"
              />
                
               </div>
               <hr className="h-1 bg-[#04177f] border-none" />
               <div className="p-4 text-center">
                 <h2 className="text-lg md:text-xl font-semibold my-4">
                   Transaction Failed
                 </h2>
                 <img
                   className={`w-32 h-32 mx-auto my-6 
                   ${isDarkMode ? "bg-black rounded-full border-[0.1px] border-black": "bg-white"}`}
                   src="./Images/failed.png"
                   alt="Failed"
                 />
                 <p className="text-sm text-red-600 font-[600] mb-8">
                  {purchaseStarTimesErrorType}
                 </p>
               {starTimesSubscriptionResponse?.data?.status  ?
               (
              <div className="flex gap-[10px] justify-between w-full px-[10px]">
                <button
                  onClick={() => ExitTheDoneButton()}
                  className="bg-[#04177f] w-[50%] max-w-xs mx-auto py-2
           text-white rounded-md font-medium"
                >
                  Done
                </button>
                <button
                  onClick={() => {
                    ReceiptButton();
                  }}
                   className={`w-[50%]  max-w-xs 
                  mx-auto py-2 
           rounded-md font-medium ${isDarkMode
             ? "text-blue-900 bg-white border-[0.2px] rounded-[10px]" 
             : "bg-white border-[0.2px]  rounded-[2px] text-black border-blue-900"}`}
                >
                  Receipt
                </button>
              </div>
         
                ): (
                   <button
                  onClick={() => ExitTheDoneButton()}
                  className="bg-[#04177f] w-[100%] max-w-xs mx-auto py-2
           text-white rounded-md font-medium"
                >
                  Done
                </button>
                 )}

               </div>
             </div>
             </Modal>
      )}
            {isLoading && (
                 <Modal>
                     <Loader/>
      
                 </Modal>
            ) } 
        {restrictUser && sessionModal === false && (
              <RestrictionPopUp/>
            ) }
            
    </div>
  )
}

export default StarTimes